import Link from "next/link"

const Header = () => {

  return (
    <header>
      <div>
        <Link href="/" prefetch={false}>
          Debicre
        </Link>
        <span style={{display: "flex",alignItems: "center",fontSize: "1.2em"}}>
          <Link href="/auth/login" prefetch={false} style={{display: "flex", padding: "12px"}}>
            <span className="material-icons">account_circle</span>
          </Link>
        </span>
      </div>
    </header>
  )
};

export default Header
